import React, { useState } from 'react';
import {
  Box,
  VStack,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Button,
  Switch,
  useColorModeValue,
  Divider,
  Card,
  CardBody,
  HStack,
  Avatar,
  Text,
  useToast,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Icon,
  Alert,
  AlertIcon,
} from '@chakra-ui/react';
import { FiUser, FiBell, FiLock, FiGlobe } from 'react-icons/fi';

const UserSettings = () => {
  const [isSaving, setIsSaving] = useState(false);
  const toast = useToast();
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const cardBg = useColorModeValue('gray.50', 'gray.700');

  const handleSave = () => {
    setIsSaving(true);
    // Simulate API call
    setTimeout(() => {
      setIsSaving(false);
      toast({
        title: 'Settings saved',
        status: 'success',
        duration: 2000,
        isClosable: true,
      });
    }, 1000);
  };

  return (
    <Box p={5}>
      <VStack spacing={6} align="stretch">
        <Heading size="lg">My Settings</Heading>

        <Tabs variant="enclosed" colorScheme="purple">
          <TabList>
            <Tab>
              <HStack>
                <Icon as={FiUser} />
                <Text>Profile</Text>
              </HStack>
            </Tab>
            <Tab>
              <HStack>
                <Icon as={FiBell} />
                <Text>Notifications</Text>
              </HStack>
            </Tab>
           
          </TabList>

          <TabPanels>
            {/* Profile Tab */}
            <TabPanel>
              <VStack spacing={6} align="stretch">
                <Card bg={cardBg}>
                  <CardBody>
                    <VStack spacing={4} align="stretch">
                      <HStack spacing={4}>
                        <Avatar size="xl" name="User Name" />
                        <VStack align="start" spacing={1}>
                          <Heading size="md">Profile Picture</Heading>
                          <Text fontSize="sm" color="gray.500">
                            Update your profile picture
                          </Text>
                          <Button size="sm" variant="outline">
                            Change Picture
                          </Button>
                        </VStack>
                      </HStack>

                      <Divider />

                      <FormControl>
                        <FormLabel>Display Name</FormLabel>
                        <Input placeholder="Enter your display name" />
                      </FormControl>

                      <FormControl>
                        <FormLabel>Email</FormLabel>
                        <Input type="email" placeholder="Enter your email" />
                      </FormControl>

                      <FormControl>
                        <FormLabel>Phone Number</FormLabel>
                        <Input type="tel" placeholder="Enter your phone number" />
                      </FormControl>
                    </VStack>
                  </CardBody>
                </Card>
              </VStack>
            </TabPanel>

            {/* Notifications Tab */}
            <TabPanel>
              <Card bg={cardBg}>
                <CardBody>
                  <VStack spacing={4} align="stretch">
                    <Heading size="md">Notification Preferences</Heading>
                    
                    <FormControl display="flex" alignItems="center" justifyContent="space-between">
                      <FormLabel mb="0">Email Notifications</FormLabel>
                      <Switch colorScheme="purple" />
                    </FormControl>

                    <FormControl display="flex" alignItems="center" justifyContent="space-between">
                      <FormLabel mb="0">Push Notifications</FormLabel>
                      <Switch colorScheme="purple" />
                    </FormControl>

                    <FormControl display="flex" alignItems="center" justifyContent="space-between">
                      <FormLabel mb="0">SMS Notifications</FormLabel>
                      <Switch colorScheme="purple" />
                    </FormControl>

                    <Alert status="info" borderRadius="md">
                      <AlertIcon />
                      You can customize which notifications you receive in your email settings.
                    </Alert>
                  </VStack>
                </CardBody>
              </Card>
            </TabPanel>

            {/* Security Tab */}
            <TabPanel>
              <Card bg={cardBg}>
                <CardBody>
                  <VStack spacing={4} align="stretch">
                    <Heading size="md">Security Settings</Heading>

                    <FormControl>
                      <FormLabel>Current Password</FormLabel>
                      <Input type="password" placeholder="Enter current password" />
                    </FormControl>

                    <FormControl>
                      <FormLabel>New Password</FormLabel>
                      <Input type="password" placeholder="Enter new password" />
                    </FormControl>

                    <FormControl>
                      <FormLabel>Confirm New Password</FormLabel>
                      <Input type="password" placeholder="Confirm new password" />
                    </FormControl>

                    <FormControl display="flex" alignItems="center" justifyContent="space-between">
                      <FormLabel mb="0">Two-Factor Authentication</FormLabel>
                      <Switch colorScheme="purple" />
                    </FormControl>
                  </VStack>
                </CardBody>
              </Card>
            </TabPanel>

            {/* Preferences Tab */}
            <TabPanel>
              <Card bg={cardBg}>
                <CardBody>
                  <VStack spacing={4} align="stretch">
                    <Heading size="md">Preferences</Heading>

                    <FormControl>
                      <FormLabel>Language</FormLabel>
                      <Input placeholder="Select language" />
                    </FormControl>

                    <FormControl>
                      <FormLabel>Time Zone</FormLabel>
                      <Input placeholder="Select time zone" />
                    </FormControl>

                    <FormControl display="flex" alignItems="center" justifyContent="space-between">
                      <FormLabel mb="0">Dark Mode</FormLabel>
                      <Switch colorScheme="purple" />
                    </FormControl>
                  </VStack>
                </CardBody>
              </Card>
            </TabPanel>
          </TabPanels>
        </Tabs>

        <Button
          colorScheme="purple"
          size="lg"
          isLoading={isSaving}
          onClick={handleSave}
        >
          Save Changes
        </Button>
      </VStack>
    </Box>
  );
};

export default UserSettings; 